module.exports = __webpack_public_path__ + "img/logo.a5d0a021.svg";